import MaterialTable from "material-table";
import React, { forwardRef } from "react";

import ScrollContainer from "./tables/ScrollContainer";
import tableIcons from "./tables/icons";

import SettingsBackupRestoreIcon from "@material-ui/icons/SettingsBackupRestore";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import LensIcon from "@material-ui/icons/Lens";
import LockOpenIcon from "@material-ui/icons/LockOpen";
import LockIcon from "@material-ui/icons/Lock";

import { withStyles } from "@material-ui/core/styles";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";

// import React from 'react';
import InputBase from "@material-ui/core/InputBase";

import { dense_theme } from "./tables/themes";

import { flatMap } from "lodash";

import {MapCircleIcon} from "./components/maps";


export default function MapList(props) {
  const data = flatMap(props.stacks, s =>
    s.elements
      .filter(e => e.type === "map")
      .map(e => ({
        id: e.id,
        stack_id: s.id,
        stack_name: s.name,
        label: e.label,
        color: e.options.color || "#888888",
        difference: e.options.difference,
        rmsd: e.options.rmsd,
        locked: e.options.locked,
        hidden: e.options.hidden
      }))
  );
  const { onLock, onReset, onHide, ...table_props } = props;

  return (
    <MuiThemeProvider theme={dense_theme}>
      <MaterialTable
        columns={[
          {
            title: "Stack",
            field: "stack_name",
            defaultGroupOrder: 1
          },
          {
            title: "",
            field: "color",
            grouping: false,
            render: rowData => <MapCircleIcon {...rowData}/>, 
            cellStyle: { width: "24px", paddingRight: "5px" }
          },
          {
            title: "Name",
            field: "label",
            grouping: false
          },
          {
            title: "rmsd",
            field: "rmsd",
            grouping: false,
            type: "numeric",
            render: rowData => (
              <InputBase
                style={{ width: 50 }}
                type="text"
                value={rowData.rmsd.toFixed(2)}
              />
            )
          }
        ]}
        actions={[
          {
            icon: props => <SettingsBackupRestoreIcon />,
            tooltip: "Reset to original rmsd",
            onClick: (event, data) => onReset(data)
          },
          rowData => ({
            icon: props => (rowData.locked ? <LockIcon /> : <LockOpenIcon />),
            tooltip: rowData.locked ? "Unlock map rmsd" : "Lock map rmsd",
            onClick: (event, data) => onLock(data)
          }),
          rowData => ({
            icon: props =>
              rowData.hidden ? <VisibilityOffIcon /> : <VisibilityIcon />,
            tooltip: rowData.hidden ? "Show map" : "Hide map",
            onClick: (event, data) => onHide(data)
          })
        ]}
        title="" //Residues'
        icons={tableIcons}
        options={{
          grouping: true,
          defaultExpanded: true,
          paging: false,
          actionsColumnIndex: -1,
          actionsCellStyle: {
            maxWidth: "85px",
            width: "85px",
            borderLeftWidth: "1px",
            borderLeftStyle: "solid",
            borderLeftColor: "#eeeeee"
            //   solid #eeeeee 0"
          }
        }}
        components={{
          Groupbar: props => "",
          Header: props => <thead />,
          Container: props => (
            <ScrollContainer>{props.children}</ScrollContainer>
          )
        }}
        data={data}
      />
    </MuiThemeProvider>
  );
}
